/* Cart drawer: adding a poster opens the cart from the side instead of leaving the page.
   Talks to Shopify's cart API (/cart.js, /cart/add.js, /cart/change.js).
   The free-shipping bar is drawn as a course: the runner moves along it toward the flag. */
(function () {
  var FREE = 11000;                                   // cents. Matches the free NZ rate in Shopify (orders over NZ$110).
  var reduce = window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches;
  var lastPct = null, opener = null, root;

  function money(c) { var s = (c / 100).toFixed(2); return "NZ$" + (s.slice(-3) === ".00" ? s.slice(0, -3) : s); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }
  function img(u, w) { return u ? u + (u.indexOf("?") > -1 ? "&" : "?") + "width=" + w : ""; }

  function api(url, body) {
    return fetch(url, body ? { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify(body) }
                           : { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }

  function build() {
    root = document.createElement("div");
    root.className = "cd"; root.id = "cart-drawer"; root.hidden = true;
    root.innerHTML =
      '<div class="cd__scrim" data-cart-close></div>' +
      '<aside class="cd__panel" role="dialog" aria-modal="true" aria-labelledby="cd-h">' +
        '<header class="cd__head"><h2 id="cd-h">Your cart</h2><button class="cd__x" type="button" data-cart-close aria-label="Close cart">&times;</button></header>' +
        '<div class="cd__ship" aria-live="polite">' +
          '<p class="cd__msg"></p>' +
          '<div class="cd__course"><div class="cd__track"><span class="cd__fill"></span><span class="cd__runner"></span></div>' +
          '<span class="cd__flag" aria-hidden="true"><svg viewBox="0 0 16 20"><path d="M2 19V1" stroke="currentColor" stroke-width="1.6"/><path d="M2.8 1.5h11l-3 3.5 3 3.5h-11z" fill="currentColor"/></svg></span></div>' +
        '</div>' +
        '<p class="cd__notice" role="alert" hidden></p>' +
        '<ul class="cd__items"></ul>' +
        '<div class="cd__empty" hidden><p>Your cart is empty.</p><a class="btn" href="/collections/nz-marathons">Shop posters</a></div>' +
        '<footer class="cd__foot">' +
          '<div class="cd__sub"><span>Subtotal</span><b class="cd__total"></b></div>' +
          '<p class="cd__small">Shipping is worked out at checkout.</p>' +
          '<a class="btn cd__go" href="/checkout">Checkout</a>' +
          '<button class="cd__keep" type="button" data-cart-close>Keep shopping</button>' +
        '</footer>' +
      '</aside>';
    document.body.appendChild(root);
    root.addEventListener("click", function (e) {
      if (e.target.closest("[data-cart-close]")) { e.preventDefault(); close(); }
      var b = e.target.closest("[data-line]");
      if (b) change(+b.dataset.line, +b.dataset.qty);
    });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape" && !root.hidden) close(); });
  }

  function ship(total) {
    var pct = Math.min(100, Math.round(total / FREE * 100)), left = FREE - total;
    root.querySelector(".cd__msg").innerHTML = total >= FREE
      ? "<b>Free shipping unlocked.</b> Your order ships free in New Zealand."
      : total === 0 ? "Free NZ shipping on orders over " + money(FREE) + "."
      : "You're <b>" + money(left) + "</b> away from free NZ shipping.";
    root.querySelector(".cd__ship").classList.toggle("is-free", total >= FREE);
    var fill = root.querySelector(".cd__fill"), run = root.querySelector(".cd__runner");
    // Start from where the bar was last time, so adding a poster visibly moves the runner on.
    var from = lastPct == null ? 0 : lastPct;
    fill.style.transition = run.style.transition = "none";
    fill.style.width = from + "%"; run.style.left = from + "%";
    void fill.offsetWidth;
    fill.style.transition = run.style.transition = "";
    requestAnimationFrame(function () { fill.style.width = pct + "%"; run.style.left = pct + "%"; });
    lastPct = pct;
  }

  function props(p) {
    return Object.keys(p || {}).filter(function (k) { return k.charAt(0) !== "_" && String(p[k]).trim() !== ""; })
      .map(function (k) { return "<li><span>" + esc(k) + "</span> " + esc(p[k]) + "</li>"; }).join("");
  }

  function render(cart) {
    var ul = root.querySelector(".cd__items");
    ul.innerHTML = cart.items.map(function (it, i) {
      var line = i + 1;
      return '<li class="cd__item">' +
        (it.image ? '<img src="' + esc(img(it.image, 160)) + '" alt="" width="64" height="90" loading="lazy">' : "<span></span>") +
        '<div class="cd__info"><a href="' + esc(it.url) + '">' + esc(it.product_title) + "</a>" +
          (it.variant_title ? '<p class="cd__var">' + esc(it.variant_title) + "</p>" : "") +
          '<ul class="cd__props">' + props(it.properties) + "</ul>" +
          '<div class="cd__row"><div class="cd__qty" aria-label="Quantity">' +
            '<button type="button" data-line="' + line + '" data-qty="' + (it.quantity - 1) + '" aria-label="One fewer">&minus;</button>' +
            "<span>" + it.quantity + "</span>" +
            '<button type="button" data-line="' + line + '" data-qty="' + (it.quantity + 1) + '" aria-label="One more">+</button></div>' +
            '<button type="button" class="cd__rm" data-line="' + line + '" data-qty="0">Remove</button></div>' +
        "</div><b class=\"cd__price\">" + money(it.final_line_price) + "</b></li>";
    }).join("");
    root.querySelector(".cd__empty").hidden = cart.item_count > 0;
    root.querySelector(".cd__foot").hidden = cart.item_count === 0;
    root.querySelector(".cd__total").textContent = money(cart.total_price);
    ship(cart.total_price);
    document.querySelectorAll("[data-cart-count]").forEach(function (el) { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
  }

  function notice(t) { var n = root.querySelector(".cd__notice"); n.textContent = t || ""; n.hidden = !t; }
  function refresh() { return api("/cart.js").then(render); }
  function change(line, qty) {
    root.classList.add("is-busy");
    api("/cart/change.js", { line: line, quantity: Math.max(0, qty) }).then(render)
      .catch(function (e) { notice(e.description || e.message || "That didn't work. Try again."); })
      .then(function () { root.classList.remove("is-busy"); });
  }

  function open() {
    opener = document.activeElement;
    root.hidden = false; document.documentElement.classList.add("cd-open");
    requestAnimationFrame(function () { root.classList.add("is-open"); });
    root.querySelector(".cd__x").focus();
  }
  function close() {
    root.classList.remove("is-open"); document.documentElement.classList.remove("cd-open");
    setTimeout(function () { root.hidden = true; }, reduce ? 0 : 320);
    if (opener && opener.focus) opener.focus();
  }

  // Add to cart without leaving the page. Empty optional fields (name, bib) are left off the order.
  function add(form) {
    var data = new FormData(form), properties = {}, btn = form.querySelector("[type=submit]");
    data.forEach(function (v, k) { var m = k.match(/^properties\[(.+)\]$/); if (m && String(v).trim() !== "") properties[m[1]] = String(v).trim(); });
    // Save the time in full (3:45 -> 3:45:00) so the order can't be misread when it's printed.
    if (properties["Finish time"] && window.RP) { var secs = RP.parseTime(properties["Finish time"]); if (secs != null) properties["Finish time"] = RP.fmtTime(secs); }
    var item = { id: parseInt(data.get("id"), 10), quantity: parseInt(data.get("quantity") || "1", 10), properties: properties };
    btn.disabled = true; btn.dataset.label = btn.dataset.label || btn.textContent; btn.textContent = "Adding…";
    notice("");
    return api("/cart/add.js", { items: [item] })
      .then(refresh).then(open)
      .catch(function (e) {
        var m = (e && (e.description || e.message)) || "Couldn't add that to your cart. Try again.";
        var msg = document.getElementById("b-msg"); if (msg) msg.textContent = m;
        refresh().then(function () { notice(m); open(); });
      })
      .then(function () { btn.disabled = false; btn.textContent = btn.dataset.label; });
  }

  document.addEventListener("DOMContentLoaded", function () {
    build();
    refresh().catch(function () {});
    document.addEventListener("click", function (e) {
      var o = e.target.closest("[data-cart-open]");
      if (o) { e.preventDefault(); refresh().then(open, open); }
    });
    var form = document.getElementById("build");
    // The product page's own submit check flags a missing time; skip adding until it's fixed.
    // (Checked here rather than via defaultPrevented, so another app's script can't silently stop the add.)
    if (form) form.addEventListener("submit", function (e) {
      e.preventDefault();
      var t = form.querySelector('[name="properties[Finish time]"]');
      if (t && window.RP && RP.parseTime(t.value) == null) return;
      add(form);
    });
  });
  window.RPCart = { open: function () { refresh().then(open); }, refresh: refresh };
})();
